import axios from 'axios';
import { CUZKbaseUrl } from '@/constants/api.js';

const CUZKServiceClient = axios.create({
  baseURL: CUZKbaseUrl,
  withCredentials: false
});

export default {
  getCadastralOverlayImage(data) {
    return `https://services.cuzk.cz/wms/wms.asp?service=WMS&request=GetMap&layers=prehledky%2CKN&styles=&format=image%2FPNG&transparent=true&version=1.3.0&width=${data.width}&height=${data.height}&crs=EPSG%3A3857&bbox=${data.ne.x},${data.ne.y},${data.sw.x},${data.sw.y}`;
  },
  getBuildingInfo(lat, lng) {
    return CUZKServiceClient.get(
      `/wfs/inspire-bu-wfs.asp?service=WFS&version=2.0.0&request=GetFeature&StoredQuery_id=GetFeatureByPoint&srsName=urn:ogc:def:crs:EPSG::4326&POINT=${lat},${lng}&FEATURE_TYPE=Building`
    );
  },
  getCadastralParcelInfo(lat, lng) {
    return CUZKServiceClient.get(
      `/wfs/inspire-cp-wfs.asp?service=WFS&version=2.0.0&request=GetFeature&StoredQuery_id=GetFeatureByPoint&srsName=urn:ogc:def:crs:EPSG::4326&POINT=${lat},${lng}&FEATURE_TYPE=CadastralParcel`
    );
  },
  getAddressInfo(lat, lng) {
    return CUZKServiceClient.get(
      `/wfs/inspire-ad-wfs.asp?service=WFS&version=2.0.0&request=GetFeature&StoredQuery_id=GetFeatureByPoint&srsName=urn:ogc:def:crs:EPSG::4326&POINT=${lat},${lng}&FEATURE_TYPE=Address`
    );
  },
  getBuildingModalUrl(id) {
    return `https://vdp.cuzk.cz/vdp/ruian/vlastnici?typ=so&id=${id}`;
  },
  getParcelModalUrl(id) {
    return `https://nahlizenidokn.cuzk.cz/ZobrazObjekt.aspx?typ=parcela&id=${id}`;
  }
};
